/**
 * Maps pictogram name formats to generated component names (Pictogram*).
 */
export const mapPictogramName = (pictogramName: string): string => {
  if (pictogramName.startsWith('Pictogram')) {
    return pictogramName
  }

  if (pictogramName.includes('-')) {
    const pascal = pictogramName
      .split('-')
      .map((part) => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase())
      .join('')
    return `Pictogram${pascal}`
  }

  return `Pictogram${pictogramName.charAt(0).toUpperCase()}${pictogramName.slice(1)}`
}
